import LinkConstants from 'constants/LinkConstants';
import { SyncType } from 'globalTypes';

export type SyncTypeTextProperties = {
  image: string;
  continueWith: string;
  switchTo: string;
  footerText: string;
  footerNextSyncType: SyncType;
  text: string;
  textLink: string;
  subtext: string;
  nextSyncType: SyncType;
  title: string;
};

const syncTypeConstants = {
  ONEROSTER: {
    image: require('assets/images/rostering/csv-oneroster.png'),
    continueWith: 'OneRoster',
    switchTo: 'Remind CSV 2.0',
    footerText: 'Remind CSV 2.0 format',
    footerNextSyncType: SyncType.remindSpreadsheetV2,
    text: 'Remind OneRoster CSV format',
    textLink: LinkConstants.FORMAT_ONEROSTER,
    nextSyncType: SyncType.remindSpreadsheetV2,
    title: 'OneRoster',
    subtext: 'Export CSV files in the OneRoster format and transfer them to Remind through SFTP.',
  },
  REMIND: {
    image: require('assets/images/rostering/csv-remindv1.png'),
    continueWith: 'Remind CSV 1.0',
    switchTo: 'Remind CSV 2.0',
    footerText: 'Remind CSV 2.0 format',
    footerNextSyncType: SyncType.remindSpreadsheetV2,
    text: 'old Remind CSV format 1.0',
    textLink: LinkConstants.FORMAT_REMIND,
    nextSyncType: SyncType.oneRosterSpreadsheet,
    title: '',
    subtext: '',
  },
  REMIND2: {
    image: require('assets/images/rostering/csv-remindv2_2.png'),
    continueWith: 'Remind CSV 2.0',
    switchTo: 'OneRoster',
    footerText: 'Remind CSV format 1.0',
    footerNextSyncType: SyncType.remindSpreadsheet,
    text: 'Remind CSV 2.0 format',
    textLink: LinkConstants.FORMAT_REMINDV2,
    nextSyncType: SyncType.oneRosterSpreadsheet,
    title: 'Remind CSV 2.0',
    subtext: 'Export CSV files from any SIS and transfer them to Remind through SFTP.',
  },
  CLASSLINK: {
    image: require('assets/images/rostering/classlink.png'),
    continueWith: '',
    switchTo: '',
    footerText: '',
    footerNextSyncType: SyncType.classlink,
    text: '',
    textLink: LinkConstants.FORMAT_CLASSLINK,
    nextSyncType: SyncType.classlink,
    title: 'ClassLink',
    subtext: 'Directly sync your SIS and Remind.',
  },
  AERIES: {
    image: require('assets/images/rostering/aeries.png'),
    continueWith: '',
    switchTo: '',
    footerText: '',
    footerNextSyncType: SyncType.aeries,
    text: '',
    textLink: LinkConstants.FORMAT_AERIES,
    nextSyncType: SyncType.aeries,
    title: 'Aeries',
    subtext: 'Directly sync your SIS and Remind.',
  }
};

export function syncMethodfromType(syncType: SyncType): string {
  const apiTypes = ['clever', 'classlink', 'aeries'];
  return apiTypes.includes(syncType) ? 'API' : 'SFTP';
}

export const textFromSyncType: { [id: string]: SyncTypeTextProperties } = {
  classlink: syncTypeConstants.CLASSLINK,
  aeries: syncTypeConstants.AERIES,
  remindSpreadsheet: syncTypeConstants.REMIND,
  remindSpreadsheetV2: syncTypeConstants.REMIND2,
  oneRosterSpreadsheet: syncTypeConstants.ONEROSTER,
};

export default syncTypeConstants;
